import { IUserRepositoryRepository } from 'repository/interfaces/user-repository'
import { SetSurgicalSchedulingBannerVisualized } from 'domain/usecases/user/set-surgical-scheduling-banner-visualized'

export class RemoteSetSurgicalSchedulingBannerVisualized
  implements SetSurgicalSchedulingBannerVisualized
{
  private readonly userRepository: IUserRepositoryRepository

  constructor(userRepository: IUserRepositoryRepository) {
    this.userRepository = userRepository
  }

  visualize(): Promise<void> {
    return this.userRepository.setSurgicalSchedulingBannerVisualized()
  }
}
